import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Injectable, inject } from '@angular/core';

import { passwordLogin } from '../../../api/identity/fn/auth/password-login';
import { refreshToken } from '../../../api/identity/fn/auth/refresh-token';
import { LoginRequest } from '../../../api/identity/models/login-request';
import { LoginApiResponse } from '../../../api/identity/models/login-api-response';
import { StrictHttpResponse } from '../../../api/identity/strict-http-response';
import { IdentityApiConfiguration } from '../../../api/identity/identity-api-configuration';
import { getUserProfile } from '../../../api/administration/fn/users/get-user-profile';
import { GhUserProfileResponse } from '../../../api/administration/models/gh-user-profile-response';
import { AdministrationApiConfiguration } from '../../../api/administration/administration-api-configuration';

export const IS_REFRESH_TOKEN   = new HttpContextToken<boolean>(() => false);
export const IS_USER_PROFILE    = new HttpContextToken<boolean>(() => false);

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http        = inject(HttpClient);
  private config      = inject(IdentityApiConfiguration);
  private adminConfig = inject(AdministrationApiConfiguration);

  getAccessToken():  string | null { return localStorage.getItem('access_token'); }
  getRefreshToken(): string | null { return localStorage.getItem('refresh_token'); }
  setAccessToken(t: string):  void { localStorage.setItem('access_token', t); }
  setRefreshToken(t: string): void { localStorage.setItem('refresh_token', t); }
  removeAccessToken(): void        { localStorage.removeItem('access_token'); }
  storeToken(t: string): void      { this.setAccessToken(t); }
  clearToken(): void               { localStorage.clear(); }
  isLoggedIn(): boolean            { return !!localStorage.getItem('access_token'); }

  // POST /api/v1/auth/login
  login(credentials: LoginRequest): Observable<StrictHttpResponse<LoginApiResponse>> {
    return passwordLogin(this.http, this.config.rootUrl, { body: credentials }).pipe(
      tap(response => {
        const token = response.body?.data?.[0];
        if (token?.accessToken)  this.setAccessToken(token.accessToken);
        if (token?.refreshToken) this.setRefreshToken(token.refreshToken);
      })
    );
  }

  // POST /api/v1/auth/refresh-token
  refreshToken(): Observable<StrictHttpResponse<LoginApiResponse>> {
    return refreshToken(
      this.http,
      this.config.rootUrl,
      undefined,
      new HttpContext().set(IS_REFRESH_TOKEN, true)
    ).pipe(
      tap(response => {
        const token = response.body?.data?.[0];
        if (token?.accessToken)  this.setAccessToken(token.accessToken);
        if (token?.refreshToken) this.setRefreshToken(token.refreshToken);
      })
    );
  }

  // GET /api/me/profile  (administration API)
  getUserProfile(): Observable<StrictHttpResponse<GhUserProfileResponse>> {
    return getUserProfile(
      this.http,
      this.adminConfig.rootUrl,
      undefined,
      new HttpContext().set(IS_USER_PROFILE, true),
    );
  }
}
